import { type z } from 'zod';

import { newRelic } from '~/utils/newRelic/newRelic';

export const safeParseWithLogging = <T extends z.ZodTypeAny>(
  data: unknown,
  schema: T,
): z.infer<T> => {
  const parsedData = schema.safeParse(data);

  if (parsedData.success) return parsedData.data;

  newRelic.noticeError(`Schema validation error`, {
    error: JSON.stringify(parsedData.error.issues),
    schema: schema.description,
  });

  // In local environments, throw an error to alert the developer of the parsing error.
  if (CONFIG.environmentName === 'local')
    throw new Error(`Schema validation error: ${JSON.stringify(parsedData.error.issues)}`);

  // Otherwise, suppress the error and (best effort) return casted data .
  return data;
};
